import React from 'react';
import PropTypes from 'prop-types';

import BWModal from '../BWModal';

const BWSelectionModal = ({
  confirmLabel = 'Xác nhận',
  closeLabel = 'Đóng',
  selectedCount = 0,
  confirmLoading = false,
  confirmDisabled = false,
  onConfirm,
  onClose,
  children,
  ...modalProps
}) => (
  <BWModal
    {...modalProps}
    size={modalProps.size || 'wide'}
    status={selectedCount > 0 ? { label: `${selectedCount} đã chọn`, tone: 'info' } : modalProps.status}
    onClose={onClose}
    closeDisabled={confirmLoading}
    cancelAction={{ label: closeLabel }}
    primaryAction={{
      label: confirmLabel,
      icon: 'fi fi-rr-check',
      onClick: onConfirm,
      loading: confirmLoading,
      disabled: confirmDisabled,
    }}>
    {children}
  </BWModal>
);

BWSelectionModal.propTypes = {
  confirmLabel: PropTypes.string,
  closeLabel: PropTypes.string,
  selectedCount: PropTypes.number,
  confirmLoading: PropTypes.bool,
  confirmDisabled: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default BWSelectionModal;
